import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import { FiPlus, FiMinus } from 'react-icons/fi';

export default function InfraestruturaProdutiva({ repeatableFields, addRepeatableField, removeRepeatableField }) {
  const { watch } = useFormContext();
  
  const incentivos = watch('incentivos_fiscais') === 'sim';
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a infraestrutura produtiva do município, incluindo parques industriais e incentivos fiscais.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="parques_industriais_numero"
          label="Número de parques industriais"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite o número de parques industriais"
          helpText="Quantidade de parques ou distritos industriais"
        />
        
        <FormField
          name="parques_industriais_ocupacao"
          label="Ocupação atual dos parques (%)"
          type="percent"
          placeholder="Digite a porcentagem de ocupação"
          helpText="Porcentagem média de ocupação dos parques industriais"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
      
      <div className="mt-4">
        <FormField
          name="parques_industriais_setores"
          label="Setores atendidos"
          placeholder="Digite os setores atendidos pelos parques industriais"
          helpText="Principais setores econômicos presentes nos parques industriais"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <FormField
          name="apl_quantidade"
          label="Quantidade de APLs"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite a quantidade de APLs"
          helpText="Número de Arranjos Produtivos Locais formalmente constituídos"
        />
        
        <FormField
          name="apl_setores"
          label="Setores principais dos APLs"
          placeholder="Digite os setores principais dos APLs"
          helpText="Principais setores econômicos dos APLs"
        />
      </div>
      
      <div className="mt-6">
        <FormField
          name="incentivos_fiscais"
          label="Incentivos fiscais para empresas"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município oferece incentivos fiscais para empresas"
        />
        
        {incentivos && (
          <div className="mt-4">
            {/* Campos repetíveis para incentivos */}
            {repeatableFields.incentivo.map((item) => (
              <div key={item.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-md font-medium">Incentivo {item.id}</h3>
                  {item.id !== 1 && (
                    <button 
                      type="button" 
                      onClick={() => removeRepeatableField('incentivo', item.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FiMinus className="mr-1" /> Remover
                    </button>
                  )}
                </div>

                <div className="mt-2">
                  <FormField
                    name={`incentivo_descricao_${item.id}`}
                    label="Descrição do incentivo"
                    type="textarea"
                    placeholder="Descreva o incentivo fiscal oferecido"
                    helpText="Detalhes sobre o tipo de incentivo, beneficiários, duração, etc."
                  />
                </div>
              </div>
            ))}
            
            <div className="mb-4">
              <button 
                type="button" 
                onClick={() => addRepeatableField('incentivo')}
                className="flex items-center text-blue-600 hover:text-blue-800"
              >
                <FiPlus className="mr-1" /> Adicionar outro incentivo
              </button>
            </div>
          </div>
        )}
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao3"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao3"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
